import { AnyAction, Reducer } from 'redux';
import { SET_AUTH } from './auth.types';
import { AuthState } from 'models/redux/auth.state';

const initialState: AuthState = {
  isAuthenticated: false,
  accessToken: '',
  user: undefined,
  countryCode: undefined,
};

const reducer: Reducer<AuthState> = (
  state: AuthState = initialState,
  action: AnyAction = { type: undefined },
) => {
  switch (action.type) {
    case SET_AUTH:
      return { ...state, ...action.payload };

    default:
      return state;
  }
};

export default reducer;
